<template>
  <div>
    <scroll-fixed-header :fixed.sync="fixed" :threshold="56">
      <div class="shane_tm_topbar">
        <div class="topbar_inner">
          <div class="logo">
            
          </div>
          <!-- End logo -->
          <div class="menu">
            <scrollactive
              class="anchor_nav"
              bezier-easing-value=".5,0,.35,1"
              :offset="95"
              :duration="100"
              :alwaysTrack="true"
            >
              <a href="#home" class="scrollactive-item">Inicio</a>
              <a href="#about" class="scrollactive-item">Acerca de</a>
              <a href="#portfolio" class="scrollactive-item">Portafolio</a>
              <a href="#testimonial" class="scrollactive-item">Contacto</a>
            </scrollactive>
          </div>
          <!-- End menu -->
        </div>
      </div>
      <!--  End shane_tm_topbar -->
    </scroll-fixed-header>

    <!-- Start shane mobile menu -->
    <div class="shane_tm_mobile_menu">
      <div class="topbar_inner">
        <div class="container bigger">
          <div class="topbar_in">
            <!-- End logo -->
            <div class="my_trigger">
              <div
                class="hamburger hamburger--collapse-r"
                :class="{ 'is-active': active }"
              >
                <div
                  class="hamburger-box"
                  @click="active = !active"
                  :aria-pressed="active ? 'true' : 'false'"
                >
                  <div class="hamburger-inner"></div>
                </div>
              </div>
              <!-- End hamburger menu -->
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown" :class="{ active: active }">
        <div class="container">
          <span
            class="close_menu"
            @click="active = !active"
            :aria-pressed="active ? 'true' : 'false'"
          >
            cerrar
          </span>
          <div class="dropdown_inner">
            <ul class="anchor_nav">
              <li>
                <div class="logo">
                  <img
                  src="../assets/img/logo/new/logo.png"
                  alt="som"
                />
                </div>
              </li>
              <li class="current">
                <a href="#home" @click="active = !active">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#about" @click="active = !active">
                  Acerca de
                </a>
              </li>
              <li>
                <a href="#portfolio" @click="active = !active">
                  Portafolio
                </a>
              </li>
              
              <li>
                <a href="#contact" @click="active = !active">
                  Contacto
                </a>
              </li>
            </ul>
            <!--<div class="social-menu">
              <Social />
            </div>-->
            <!-- End social share -->
          </div>
        </div>
        <!-- End container -->
      </div>
    </div>
    <!-- End shane mobile menu -->
  </div>
</template>

<script>
//import Social from "../components/SocialTwo.vue";
export default {
  components: {
    //Social,
  },
  data() {
    return {
      active: false,
      fixed: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
